import { isRenderablePackItem } from '@/components/app/cards/PacksList/types';
import useSearch from '@/hooks/app/useSearch';

import SearchResults from '../SearchResults';
import { SearchStyledLoader } from '../styles';

export interface Props {
	query: string;
	selectedCategory: string[];
	selectedCategoryValue: string[];
	selectedDuration: string[];
	selectedDurationValue: string[];
}

const SearchBody: React.FC<Props> = ({
	query,
	selectedCategory,
	selectedCategoryValue,
	selectedDuration,
	selectedDurationValue,
}) => {
	const {
		isLoading: searchIsLoading,
		pack,
		usedFallback,
		message,
		query_id,
		search_index,
	} = useSearch(query, selectedCategory, selectedDuration);
	// Same predicate CardGrid uses to decide what it renders, so this can't disagree
	// with CardGrid about whether a result set is actually empty.
	const packItems = pack?.items?.filter(isRenderablePackItem);

	if (searchIsLoading) {
		return <SearchStyledLoader />;
	}

	return (
		<SearchResults
			query={query}
			query_id={query_id}
			search_index={search_index}
			category={selectedCategoryValue}
			duration={selectedDurationValue}
			usedFallback={usedFallback}
			message={message}
			pack={pack}
			packItems={packItems}
		/>
	);
};

export default SearchBody;
